    angular.module('egg.order.integration', ['core'])
        .factory('EggErpIntegration', function ($resource) {
            return $resource('/crm/api/egg-order-integration', {}, {
                showBuffer: {method: 'GET', isArray: true, url: '/crm/api/egg-order-integration/buffer'},
                import: {method: 'POST', isArray: true, url: '/crm/api/egg-order-integration/import'},
                // reset: {method: 'POST', url: '/crm/api/egg-order-integration/buffer/reset'},
            });
        })
        .service('EggOrderIntegrationService', function (modals) {
            this.bufferModal = function () {
                modals.open('app/egg/order/erp-integration/buffer-modal.tpl.html', 'EggOrderIntegrationDialogController', {}, {size: "lg"}, "vm");
            };
        })
        .controller('EggOrderIntegrationDialogController', function ($scope, $rootScope, toastr, $uibModalInstance, data, EggErpIntegration) {
            var vm = this;

            vm.cancel = function () {
                $uibModalInstance.dismiss('Canceled');
            };

            function loadBuffer() {
                EggErpIntegration.showBuffer().$promise
                    .then(function (items) {
                        vm.items = items;
                    })
                    .catch(function () {
                        vm.items = [];
                    })
            }

            loadBuffer();


            vm.import = function () {
                delete vm.items;
                return EggErpIntegration.import().$promise
                    .then(function (items) {
                        $rootScope.$broadcast('egg.order.updated');
                        toastr.success("Zakończono")
                        vm.items = items.map(function (it) {
                            var item = it.item;
                            item.processed = {
                                status: it.status,
                                message: it.message
                            }
                            return item;
                        });
                    })
                    .catch(function () {
                        loadBuffer();
                    })
            }

        });
